import React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Tabs } from "antd";
import {
  UserIcon,
  BuildingStorefrontIcon,
  ComputerDesktopIcon,
  CodeBracketIcon,
  PuzzlePieceIcon,
  IdentificationIcon,
  UsersIcon,
  BellIcon,
  BanknotesIcon,
  TicketIcon,
} from "@heroicons/react/20/solid";
import { useCurrentUser } from "../../utils/CurrentUserContext";
import { CompanyType } from "../../__generated__/graphql";

const SettingsAdvanced = () => {
  const {user, isAdmin} = useCurrentUser();
  const navigate = useNavigate();
  const location = useLocation();

  const isAdvertiser = user.company.type === CompanyType.Advertiser
  const isAgency = user.company.type === CompanyType.Agency
  const isPublisher = user.company.type === CompanyType.Publisher

  const tabs = [
    { name: "Profile", to: "profile", icon: UserIcon },
    { name: "Notifications", to: "notifications", icon: BellIcon, visible: isPublisher },
    { name: "Account", to: "account", icon: IdentificationIcon },
    { name: "Users", to: "users", icon: UsersIcon },
    { name: "Websites", to: "websites", icon: ComputerDesktopIcon, visible: isPublisher },
    { name: "Templates", to: "templates", icon: CodeBracketIcon, visible: isPublisher },
    { name: "Placements", to: "placements", icon: PuzzlePieceIcon, visible: isPublisher },
    { name: "Revenue", to: "accountreportingwebsites", icon: BanknotesIcon, visible: isPublisher && isAdmin },
    { name: "Campaigns", to: "campaignreporting", icon: BanknotesIcon, visible: isPublisher && isAdmin },
    { name: "Advertisers", to: "advertisers", icon: BuildingStorefrontIcon, visible: isAgency || isPublisher},
    { name: "Preferred Deals", to: "preferred-deals", icon: TicketIcon, visible: isPublisher && user.company.allowPreferredDeals },
    { name: "Cost", to: "cost", icon: BanknotesIcon, visible: isAdvertiser || isAgency},
    { name: "Labels", to: "labels", icon: TicketIcon, visible: isAdmin },
  ].filter(({visible = true}) => visible);

  const activeKey = tabs.find(tab => location.pathname.endsWith(`/${tab.to}`))?.to || tabs[0]?.to;

  const tabItems = tabs.map(tab => ({
    key: tab.to,
    label: (
      <span className="flex items-center gap-1.5">
        <tab.icon className="h-4 w-4" />
        {tab.name}
      </span>
    ),
  }));

  return (
    <div>
      <Tabs
        activeKey={activeKey}
        items={tabItems}
        onChange={(key) => navigate(key)}
      />

      <div className="py-2">
        <Outlet />
      </div>
    </div>
  );
};

export default SettingsAdvanced;
